import {
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Switch,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import WSSelectField from "../../Components/Select/WSSelect";
import { useForm, useFormContext } from "react-hook-form";
import {
  customValidation,
  validations,
} from "../../commonFunctions/CommonFunctions";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDateField from "../../Components/DateField/WSDateField";
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox";

export const AdditionalFields: React.FC<any> = React.memo((props) => {
  const { control, register } = useForm();


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={1}>
          <WSSCheckBoxField
            label=""
            id="field1"
            control={control}
            {...register("field1")}
            rules={{ required: false }}
            name="field1"
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <WSTextField
            label={"Additional Field 1 Name"}
            {...register("field1")}
            id="field1"
            name="field1"
            control={control}
            rules={{ required: false }}
            defaultValue={"Drug License No"}
            disabled
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <WSTextField
            label={"Enter Value For Drug License No"}
            {...register("druglicense")}
            id="druglicense"
            name="druglicense"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12}>
        <FormControlLabel
                control={<Switch  />}
                label="Show In Print"
              />
        </Grid>
        <Grid item xs={12} sm={1}>
          <WSSCheckBoxField
            label=""
            id="field2"
            control={control}
            {...register("field2")}
            rules={{ required: false }}
            name="field2"
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <WSTextField
            label={"Additional Field 2 Name"}
            {...register("field2")}
            id="field2"
            name="field2"
            control={control}
            defaultValue={"PAN Number"}
            disabled
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <WSTextField
            label={"Enter Value For PAN Number"}
            {...register("panNumber")}
            id="panNumber"
            name="panNumber"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12}>
           <FormControlLabel
                control={<Switch  />}
                label="Show In Print"
              />
        </Grid>

        <Grid item xs={12} sm={1}>
          <WSSCheckBoxField
            label=""
            id="field3"
            control={control}
            {...register("field3")}
            rules={{ required: false }}
            name="field3"
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <WSTextField
            label={"Additional Field 3 Name"}
            {...register("field3")}
            id="field3"
            name="field3"
            control={control}
            defaultValue={"Age/Gender"}
            disabled
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <WSTextField
            label={"Enter Value For Age/Gender"}
            {...register("ageGender")}
            id="ageGender"
            name="ageGender"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12}>
         <FormControlLabel
                control={<Switch  />}
                label="Show In Print"
              />
        </Grid>
        <Grid item xs={12} sm={1}>
          <WSSCheckBoxField
            label=""
            id="field4"
            control={control}
            {...register("field4")}
            rules={{ required: false }}
            name="field4"
          />
        </Grid>
        <Grid item xs={12} sm={5}>
          <WSDateField
            id="field4"
            name="field4"
            label={"Additional Field 4 Name"}
            dateFormat="DD-MM-YYYY"
            denyFuturOrPast="custom"
            control={control}
            defaultValue={"Drug License Exp.Date"}
            disabled
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12} sm={5}>
            <WSDateField
            id="expDate"
            name="expDate"
            label={"Enter Value For Drug License Exp.Date"}
            dateFormat="DD-MM-YYYY"
            denyFuturOrPast="custom"
            control={control}
            rules={{ required: false }}
          />
        </Grid>
        <Grid item xs={12}>
         <FormControlLabel
                control={<Switch  />}
                label="Show In Print"
              />
        </Grid>
      </Grid>
    </>
  );
});
